import createVueComponent from '../createVueComponent';

const ChevronLeft = createVueComponent('ChevronLeftIcon', [
  ['path', { d: 'm15 18-6-6 6-6', key: '1wnfg3' }],
]);

export default ChevronLeft;
